import ReactDOM from 'react-dom';
import React from 'react';
import store from './dal/store';
import { Provider } from 'react-redux';
import CompareBundles from './ui/compare-bundles';

/**
 * entry point
 * https://dev.waves.com/compare-bundles?ids=82-29-81-88
 * https://dev.waves.com/compare-bundles?ids=76-88
 * https://wavesaudio.atlassian.net/browse/DSWEB-3160
 */
const init = () => {
    const $root = document.getElementById('compare-bundles-app');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <CompareBundles />
            </Provider>
        </React.StrictMode>,
        $root
    );
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});